<template>
  <v-data-iterator
    :items="roles.data"
    :page.sync="c_page"
    :items-per-page.sync="c_size"
    :server-items-length="roles.meta.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <im-role-card
        v-for="(role, index) in slot.items"
        :role="role"
        :key="index"
        @edit="$emit('edit', role)"
      />
    </template>
  </v-data-iterator>
</template>

<script>

  export default {

    components: {
      'im-role-card': () => import('@/components/Admin/Role/RoleCard')
    },

    props: {
      roles: Object
    },

    data: () => ({
      pagination: {
        page: 1,
        size: 10,
      },
      itemsPerPageOptions: [10, 15, 30, 50]
    }),

    computed: {

      c_page: {
        get() {
          return this.pagination.page;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: val,
            size: this.pagination.size,
          })
        }
      },

      c_size: {
        get() {
          return this.pagination.size;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: this.pagination.page,
            size: val
          })
        }
      }

    }

  }

</script>